<template>
  <div>
    <es-form :padding="{ padding: '0 1.15rem 1.15rem' }">
      <template #es-form>
        <!-- TODO: Talk to design team about only showing options for stateUsers. -->
        <div
          v-if="isStateUser"
          class="row removeUnderline"
        >
          <div class="field is-horizontal">
            <div class="field-label is-normal">
              <label class="label">
                <span v-if="!personTypes.length">
                  {{ getFieldLabel(`PER:${personType}:DIRECTMATCH:DISTRICT_CODE`) }}
                </span>
                <span v-else>
                    {{ getFieldLabel(`PER:${personTypes[0].code}:DIRECTMATCH:DISTRICT_CODE`) }}
                </span>
              </label>
            </div>
            <div class="field-body">
              <div class="field">
                <div class="control">
                  <div class="buttons has-addons">
                    <button
                      v-for="(item, index) in availableDistrictOptions"
                      :key="index"
                      class="button button--form"
                      :class="{'is-active': selectedDistrictType === item.option}"
                      @click="selectedDistrictType = item.option"
                      style="min-width: 150px"
                    >
                      {{ item.label }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="!hasAllDistrictsSelected || !isStateUser"
          class="row removeUnderline"
        >
          <div class="field is-horizontal">
            <div class="field-label is-normal">
              <label class="label">
                <span v-if="!personTypes.length">
                  {{ getFieldLabel(`PER:${personType}:DIRECTMATCH:DISTRICT_CODE`) }} Name
                </span>
                <span v-else>
                    {{ getFieldLabel(`PER:${personTypes[0].code}:DIRECTMATCH:DISTRICT_CODE`) }} Name
                </span>
              </label>
            </div>
            <div class="field-body">
              <!-- TODO: Not allow single district user to clear districts. -->
              <es-select
                api="districts"
                :error-msg="errorMsgDistrict"
                :has-error="hasErrorDistrict"
                key-value="code"
                :pre-selected="districtCodes"
                ref="selDistricts"
                :search="true"
                search-min-length="2"
                :value-tpl-fn="(result) => `${result.location.name} (${result.code})`"
                @update:values="districts = $event"
              />
            </div>
          </div>
        </div>
        <div class="row removeUnderline">
          <div class="field is-horizontal">
            <div class="field-label is-normal">
              <label class="label">
                <span v-if="!personTypes.length">
                  {{ getFieldLabel(`PER:${personType}:DIRECTMATCH:SCHOOL_CODE`) }}
                </span>
                <span v-else>
                    {{ getFieldLabel(`PER:${personTypes[0].code}:DIRECTMATCH:SCHOOL_CODE`) }}
                </span>
              </label>
            </div>
            <div class="field-body">
              <div
                v-if="isAllSchools"
                class="field"
              >
                <div class="control">
                  <input
                    class="input"
                    type="text"
                    value="All Schools"
                    disabled
                  >
                </div>
              </div>
              <es-select
                v-else
                api="schools"
                :api-query-params="getDistrictParams"
                :error-msg="errorMsgSchool"
                :has-error="hasErrorSchool"
                keyValue="code"
                :pre-selected="schoolCodesPromises"
                ref="selSchools"
                :search="true"
                search-min-length="2"
                :sub-value-tpl-fn="(result) =>
                  `${result.districtLocation.name} (<i>${result.districtCode }</i>)`"
                :value-tpl-fn="(result) => `${result.location.name} (${result.code})`"
                @update:values="schools = $event"
              />
            </div>
          </div>
        </div>
        <div class="row removeUnderline" v-if='dmPersonTypeMatching'>
          <div class="field is-horizontal">
            <div class="field-label is-normal">
              <label class="label">
                Person Type
              </label>
            </div>
            <div class="field-body">
              <es-select
                v-on:update:values="personTypes = $event;"
                valueTpl="${name}"
                :error-msg="errorMsgPersonType"
                :has-error="hasErrorPersonType"
                :preSelected=null
                :setValues="sortedPersonTypes"
                keyValue="code"
                ref="selPersonType"
                />
              </div>
           </div>
        </div>
        <div
          v-if="enableMatchTypeSelection"
          class="row removeUnderline"
        >
          <div class="field is-horizontal">
            <div class="field-label is-normal">
              <label class="label">
                Match Type
              </label>
            </div>
            <div class="field-body">
              <es-select
                v-on:update:values="matchTypes = $event;"
                :preSelected= null
                :disabled="!personTypes.length && dmPersonTypeMatching"
                :error-msg="errorMsgMatchType"
                :has-error="hasErrorMatchType"
                key-value="programCode"
                ref="selMatchType"
                :setValues="filterProgramsByPersonType"
                :value-tpl-fn="(result) => `${result.program.description}`"
              />
            </div>
          </div>
        </div>
      </template>
    </es-form>
    <div
      class="is-flex flex-justify--end flex-align--center"
      style="margin-right: 5.15rem; padding-bottom: 2rem"
    >
      <button
        class="button button-link has-underline"
        @click="reset"
        style="margin-right: 1rem"
      >
        Reset
      </button>
      <!-- TODO: disable button when loading match -->
      <!-- TODO: hover text while provess control running? -->
      <button
        class="button is-primary"
        @click="checkForm"
        :disabled="loadingMatch || (processControlRunning && hasAllDistrictsSelected)"
      >
        {{ properties['BUTTON_LABEL-ASSIGN_EXISTING'] }}
      </button>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import {
  mapGetters,
  mapActions,
} from 'vuex';
import EsForm from '@/components/EsForm.vue';
import EsSelect from '@/components/EsSelect.vue';
import FieldLabels from '@/mixins/FieldLabels';
import NotificationManager from '@/mixins/NotificationManager';
import PermissionManager from '@/mixins/PermissionManager';

export default {
  mixins: [
    FieldLabels,
    NotificationManager,
    PermissionManager,
  ],
  components: {
    EsForm,
    EsSelect,
  },
  props: {
    // value coming from router to help return the match type id for the give matchTypeCode.
    matchTypeCode: {
      type: String,
    },
    dmPersonTypeMatching: {
      type: Boolean,
    },
    personType: {
      type: String,
    },
    processControl: {
      type: Object,
    },
    sortedPersonTypes: {
      type: Array,
    },
  },
  data() {
    return {
      districtCodes: [], // single district users to pass in distictCode to es-selct
      districtOptions: [], // button options for District row in form
      districts: [], // slected districts
      errorMsgDistrict: null,
      errorMsgMatchType: null,
      errorMsgPersonType: null,
      errorMsgSchool: null,
      hasErrorDistrict: null,
      hasErrorMatchType: null,
      hasErrorPersonType: null,
      hasErrorSchool: null,
      loadingMatch: null, // loading variable for loading match
      loadingMatchError: null, // loading match variable for showing loading error
      matchTypes: [], // selected match types
      resetting: null,
      schoolCodes: [], // single school users to setup pre-selected data in es-select
      schools: [], // selectes schools
      selectedDistrictType: null, // selected District option as a String,
      personTypes: [],
      selectedPersonType: [],
      programs: [],
    };
  },
  async created() {
    this.loadPrograms();
    this.checkUserTypes();
    this.setDataElements();
    this.selectedPersonType = JSON.parse(JSON.stringify(this.personTypes));
    await this.loadPersonTypes();
  },
  mounted() {
    this.checkProcessControl();
  },
  watch: {
    hasAllDistrictsSelected() {
      // reset districts array when switching back to All Districts
      if (this.hasAllDistrictsSelected) {
        this.districts = [];
        this.checkUserTypes();
      }
    },
    // watch required fields
    // when their values change, validate their values
    districts() {
      if (!this.resetting) {
        this.validateDistrict();
      }
    },
    schools() {
      if (!this.resetting) {
        this.validateSchool();
      }
    },
    // matchTypes() {
    //   if (!this.resetting) {
    //     this.validateMatchType();
    //   }
    // },
    personTypes(newVal) {
      if (!this.resetting) {
        this.validatePersonType();
      }
      if (JSON.stringify(newVal) !== JSON.stringify(this.selectedPersonType)) {
        this.$refs.selMatchType.clear();
      }
      this.selectedPersonType = JSON.parse(JSON.stringify(newVal));
    },
  },
  asyncComputed: {
    async schoolCodesPromises() {
      const promises = [];
      this.schoolCodes.forEach(code => promises
        .push(axios.get(`districts/${code.split(/[:]+/)[1]}/schools/${code.split(/[:]+/)[0]}`)));
      const responses = await Promise.all(promises);
      return responses.map(r => r.data);
    },
  },
  computed: {
    ...mapGetters([
      'isDistrictUser',
      'isMultiSchoolUser',
      'isSingleDistrictUser',
      'isSingleSchoolUser',
      'isStateUser',
      'userDistricts',
      'userSchools',
    ]),
    ...mapGetters('lookups', [
      'activeMatchTypes',
    ]),
    ...mapGetters('propertiesModule', [
      'properties',
    ]),
    availableDistrictOptions() {
      return this.districtOptions.filter(x => x.permission === true);
    },
    enableMatchTypeSelection() {
      //  If there is default value in District or School field, or the user selects a specific
      // district or school, enable match types.

      // cases to cover:
      // 1. All Districts and All Schools
      // 2. Specific Districts and selected district and All Schools
      // 3. All Districts and selected school
      // 4. district and school selected

      if ((this.hasAllDistrictsSelected && this.isAllSchools) // case 1
        || (!this.hasAllDistrictsSelected && this.districts.length && this.isAllSchools) // case 2
        || (this.hasAllDistrictsSelected && this.schools.length) // case 3
        || (this.districts.length && this.schools.length) // case 4
      ) {
        return true;
      }
      return false;
    },
    formDataBody() {
      const body = {};
      body.matchTypeId = this.matchTypeId;
      body.programCode = this.matchTypes.length ? this.matchTypes[0].programCode : null;
      body.districtCode = this.districts.length ? this.districts[0].code : null;
      body.schoolCode = this.schools.length ? this.schools[0].code : null;
      return body;
    },
    getDistrictParams() {
      const params = {};
      params.districtCode = this.districts.map(d => d.code);
      return params;
    },
    hasAllDistrictsSelected() {
      return this.selectedDistrictType === 'All Districts';
    },
    isAllSchools() {
      // show disabled All Schools input when:
      // 1. isStateUser
      // 2. isDistrictUser (some number of districts and all schools)
      // 3. (some number of districts && some number of schools && no selected district)
      return this.isStateUser
          || this.isDistrictUser
          || (!this.isStateUser && !this.isSingleSchoolUser && !this.districts.length);
    },
    matchTypeId() {
      if (this.hasAllDistrictsSelected) {
        return this.matchTypeDmAllId;
      }
      return this.matchTypeDmDisId;
    },
    matchTypeDmAllId() {
      return this.activeMatchTypes.find(m => m.code === 'DMALL').id;
    },
    matchTypeDmDisId() {
      return this.activeMatchTypes.find(m => m.code === 'DMDIS').id;
    },
    matchTypeQueryParams() {
      const params = { matchEnabled: true };
      if (this.districts.length) {
        params.distictCode = this.districts[0].code;
      }
      return params;
    },
    processControlProgram() {
      return this.processControl.program || '';
    },
    processControlRunning() {
      return ['PROCESSING', 'QUEUED'].includes(this.processControl.status);
    },
    processControlTime() {
      if (this.processControl.hoursLeftEstimate > 1.0) {
        return this.processControl.hoursLeftEstimate;
      }
      return 'less than one';
    },
    filterProgramsByPersonType() {
      if (this.dmPersonTypeMatching === false) {
        return this.programs;
      }
      const selectedPersonType = this.personTypes.map(type => type.code);
      return this.programs.filter(
        program => selectedPersonType.includes(program.program.personTypeCode),
      );
    },
    validForm() {
      return !this.hasErrorDistrict && !this.hasErrorSchool
        && !this.hasErrorMatchType && !this.hasErrorPersonType;
    },
  },
  methods: {
    ...mapActions('lookups', [
      'loadPersonTypes',
    ]),
    async loadPrograms() {
      try {
        const res = await axios.get(`matchtypes/${this.matchTypeId}/programs?matchEnabled=true`);
        this.programs = res.data;
      } catch (error) {
        this.$root.$emit('setLoadingError', true);
      }
    },
    checkForm() {
      this.validateAllFields();

      if (this.validForm) {
        this.hideNotification();
        this.match();
      } else {
        this.showNotification('danger',
          ['There were some errors. Please fix the errors highlighted in the fields below.']);
      }
    },
    checkProcessControl() {
      if (this.processControlRunning) {
        this.messages = [
          `Warning: A ${this.processControlProgram} State Batch is currently running and
          should be done in ${this.processControlTime} hour(s). You cannot run another
          state match until this process is completed.`,
        ];

        this.showNotification('warning', this.messages);
      }
    },
    checkUserDistricts() {
      // if the user is a single-distrit-user then set selectedDistrictType to Specific Districts
      // and assign districtCodes to a list of codes from the store to pass into es-select.
      // if the user is multi-district-user then set selectedDistrictType to Specific Districts.
      // if the user is a state-user then default selectedDistrictType to All Districts.
      if (this.isSingleDistrictUser) { // single-district
        this.selectedDistrictType = 'Specific Districts';
        this.districtCodes = [this.userDistricts[0].code];
        this.districts = this.districtCodes.map(d => ({ code: d }));
      } else if (!this.isStateUser) { // multi-district
        this.selectedDistrictType = 'Specific Districts';
      } else if (this.isStateUser) { // all-district
        this.selectedDistrictType = 'All Districts';
      }
    },
    checkSingleSchoolUser() {
      // if the user is a single-school-user then assign schoolCodes to school:district String
      // from the store to prepare schoolCodePromises computed prop.
      if (this.isSingleSchoolUser) {
        this.schoolCodes = [`${this.userSchools[0].code}:${this.userDistricts[0].code}`];
        this.schools = this.schoolCodes
          .map(code => ({ districtCode: code.split(/[:]+/)[1], code: code.split(/[:]+/)[0] }));
      } else {
        this.schools = [];
      }
    },
    // check initial district and school permissions to set default data selections
    checkUserTypes() {
      this.checkUserDistricts();
      this.checkSingleSchoolUser();
    },
    async match() {
      try {
        this.loadingMatch = true;
        this.loadingMatchError = false;
        // post data
        const postResponse = await axios.post('/directmatch/batches', this.formDataBody);
        // get batch details with batchId from the POST
        const getResponse = await axios.get('directmatch/batches',
          {
            params: { ids: postResponse.data.id },
          });
        this.$emit('batchResponse', getResponse.data.data); // emit batch data up to parent level
      } catch (e) {
        this.loadingMatchError = true;
      } finally {
        this.loadingMatch = false;
      }
    },
    reset() {
      this.resetting = true;
      this.resetValues();
      this.hasErrorDistrict = false;
      this.hasErrorSchool = false;
      this.hasErrorMatchType = false;
      this.hasErrorPersonType = false;
      this.hideNotification();
    },
    resetValues() {
      this.checkUserDistricts();
      this.checkSingleSchoolUser();
      this.$refs.selMatchType.clear();
      if (this.$refs.selPersonType) this.$refs.selPersonType.clear();
    },
    setDataElements() {
      this.districtOptions = [
        {
          option: 'All Districts',
          label: `All ${this.getFieldLabel(`PER:${!this.personTypes.length ? this.personType : this.personTypes[0].code}:DIRECTMATCH:DISTRICT_CODE`)}s`,
          permission: this.hasModule('DRMCH:MATCH:STATEMATCH'),
        },
        {
          option: 'Specific Districts',
          label: `Specific ${this.getFieldLabel(`PER:${!this.personTypes.length ? this.personType : this.personTypes[0].code}:DIRECTMATCH:DISTRICT_CODE`)}s`,
          permission: true,
        },
      ];
      this.selectedDistrictType = this.availableDistrictOptions.length === 1 ? this.availableDistrictOptions[0].option : 'All Districts';
    },
    validateAllFields() {
      this.validateDistrict();
      this.validateSchool();
      this.validateMatchType();
      this.validatePersonType();
    },
    validateDistrict() {
      if (!this.hasAllDistrictsSelected && !this.districts.length) {
        this.hasErrorDistrict = true;
        this.errorMsgDistrict = `${this.getFieldLabel(`PER:${!this.personTypes.length ? this.personType : this.personTypes[0].code}:DIRECTMATCH:DISTRICT_CODE`)} is required.`;
      } else {
        this.hasErrorDistrict = false;
        this.errorMsgDistrict = null;
      }
    },
    validateSchool() {
      if (!this.isAllSchools && !this.schools.length) {
        this.hasErrorSchool = true;
        this.errorMsgSchool = `${this.getFieldLabel(`PER:${!this.personTypes.length ? this.personType : this.personTypes[0].code}:DIRECTMATCH:DISTRICT_CODE`)} is required.`;
      } else {
        this.hasErrorSchool = false;
        this.errorMsgSchool = null;
      }
    },
    validateMatchType() {
      if (!this.matchTypes.length) {
        this.hasErrorMatchType = true;
        this.errorMsgMatchType = 'Match Type(s) is required.';
      } else {
        this.hasErrorMatchType = false;
        this.errorMsgMatchType = null;
      }
    },
    validatePersonType() {
      if (!this.personTypes.length && this.dmPersonTypeMatching) {
        this.hasErrorPersonType = true;
        this.errorMsgPersonType = 'Person Type is required.';
      } else {
        this.hasErrorPersonType = false;
        this.errorMsgPersonType = null;
      }
    },
  },
};
</script>

<style lang="sass" scoped>
</style>
